'use client';

import { EntityProcedureScheduleCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedure-schedule-card.component';
import { EntityProcedurePlaceCard } from '@/app/(main)/(pages)/_components/entities/entity-procedure/_components/entity-procedure-place-card.component';
import { EntityProceduresSection } from '@/app/(main)/(pages)/_components/entities/entity-procedure/entity-procedures-section.component';
import { UseProfessionalProceduresReturn } from '@/app/(main)/(pages)/(institucional)/(index)/profissionais/[slug]/_hooks/use-professional-procedures.hook';

interface ProfessionalSchedulesSectionProps {
  procedures: UseProfessionalProceduresReturn;
  className?: string;
}

export function ProfessionalSchedulesSection({ procedures, className }: ProfessionalSchedulesSectionProps) {
  return (
    <EntityProceduresSection
      procedures={procedures}
      title="Consultas e horários"
      className={className}
      renderProcedure={(procedure, index) => (
        <EntityProcedureScheduleCard
          key={procedure.id}
          accordionKey={procedure.id}
          title={procedure.name}
          defaultOpen={index === 0}
        >
          {procedure.places.map((place) => (
            <EntityProcedurePlaceCard key={place.id} place={place} />
          ))}
        </EntityProcedureScheduleCard>
      )}
    />
  );
}
